import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const PPZahtjevKC: IModel = {
  title: '',
  apiPath: 'prostorni-planovi/zahtjevi/{id}/cestice',
  layer: 'pp_zahtjev_kc',
  forms: {
    default: {
      fields: [
        'kc',
        'ko_mb',
        'ko_naziv',
        'podnositelj_napomena',
        'vlasnik',
        'vlasnik_adresa',
        'posjednik',
        'posjednik_adresa',
        'kategorija_id',
        'primjedba',
        'vlasnistvo_status_id',
        'zahtjev_kc_status_id',
        'is_provjereno',
        'dokumenti_suglasnosti',
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'kc',
        'ko_mb',
        'ko_naziv',
        'podnositelj_napomena',
        'vlasnik',
        'vlasnik_adresa',
        'posjednik',
        'posjednik_adresa',
        'kategorija_id',
        'primjedba',
        'vlasnistvo_status_id',
        'zahtjev_kc_status_id',
        'is_provjereno',
        'dokumenti_suglasnosti_docs',
      ],
    },
  },
  fields: [
    coreFields.id,
    coreFields.active,
    {
      title: 'KC',
      source: 'kc',
      ttoken: 'pp:kc',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'KO MB',
      source: 'ko_mb',
      ttoken: 'pp:ko_mb',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'KO Naziv',
      source: 'ko_naziv',
      ttoken: 'pp:ko_naziv',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'Podnositelj Napomena',
      source: 'podnositelj_napomena',
      ttoken: 'pp:podnositelj_napomena',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'Vlasnik',
      source: 'vlasnik',
      ttoken: 'pp:vlasnik',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'Vlasnik Adresa',
      source: 'vlasnik_adresa',
      ttoken: 'pp:vlasnik_adresa',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'Posjednik',
      source: 'posjednik',
      ttoken: 'pp:posjednik',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'Posjednik Adresa',
      source: 'posjednik_adresa',
      ttoken: 'pp:posjednik_adresa',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'KC Corr',
      source: 'kc_corr',
      ttoken: 'pp:kc_corr',
      type: 'text',
      filter: true,
    },
    {
      title: 'Primjedba',
      source: 'primjedba',
      ttoken: 'pp:primjedba',
      type: 'multiline',
      maxRows: 5,
      rows: 5,
      filter: true,
      width: 'full',
    },
    {
      title: 'Vlasnistvo Status ID',
      source: 'vlasnistvo_status_id',
      ttoken: 'pp:vlasnistvo_status_id',
      type: 'picker',
      items: {
        labels: [
          'pp:zahtjev_vlasnistvo_statusi.ok',
          'pp:zahtjev_vlasnistvo_statusi.one_of',
          'pp:zahtjev_vlasnistvo_statusi.all_diff',
          'pp:zahtjev_vlasnistvo_statusi.same_addr',
          'pp:zahtjev_vlasnistvo_statusi.posjednik',
          'pp:zahtjev_vlasnistvo_statusi.one_of_posjed',
          'pp:zahtjev_vlasnistvo_statusi.posjed_addr',
        ],
        values: [1, 2, 3, 4, 5, 6, 7],
      },
      filter: true,
      width: 'full',
      translate: true,
    },
    {
      title: 'Status zahtjeva',
      source: 'zahtjev_kc_status_id',
      ttoken: 'pp:zahtjev_kc_status_id',
      type: 'picker',
      items: {
        labels: [
          'pp:zahtjev_kc_statusi.razmatranje',
          'pp:zahtjev_kc_statusi.prihvacen',
          'pp:zahtjev_kc_statusi.odbijen',
          'pp:zahtjev_kc_statusi.dijelomicno',
        ],
        values: [10, 20, 30, 40],
      },
      translate: true,
      filter: true,
      width: 'full',
    },
    {
      title: 'Kategorija',
      source: 'kategorija_id',
      ttoken: 'pp:zahtjevi.kategorija_id',
      type: 'picker',
      items: {
        labels: [
          'pp:zahtjev_kc_kategorije.prosirenje',
          'pp:zahtjev_kc_kategorije.prenamjena',
        ],
        values: [10, 20],
      },
      translate: true,
      filter: true,
      width: 'full',
    },
    {
      title: 'Dokumenti suglasnosti',
      source: 'dokumenti_suglasnosti',
      ttoken: 'pp:zahtjevi.dokumenti_suglasnosti',
      type: 'picker',
      multi: true,
      subModel: {
        apiPath: 'core/documents-for-entity/{zahtjev_gid}?view=picker',
        format: '{label}',
        idattr: 'value',
      },
      filter: false,
      width: 'full',
    },
    {
      title: 'Suglasnosti',
      source: 'dokumenti_suglasnosti_docs',
      ttoken: 'pp:zahtjevi.dokumenti_suglasnosti',
      type: 'document',
      readonly: true,
      subModel: {
        apiPath: 'core/documents',
        format: '{name}',
      },
    },
    {
      title: 'Kriteriji odbijanja',
      source: 'kriteriji_odbijanja',
      ttoken: 'pp:zahtjevi.kriteriji_odbijanja',
      type: 'array',
      filter: true, // probably doesnt work right?
      readonly: true,
    },
    {
      title: 'Provjereno',
      source: 'is_provjereno',
      ttoken: 'pp:zahtjevi.is_provjereno',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },
    {
      title: 'zahtjev_gid',
      source: 'zahtjev_gid',
      ttoken: 'common.gid',
      type: 'text',
      filter: true,
      readonly: true,
    },
    // commonFields.wkt,
    coreFields.geom,
    coreFields.gid,
    coreFields.created_on,
  ],
};

export default PPZahtjevKC;
